import { createContext } from 'react';
import { DevicesState } from 'shared/providers/devices/hooks/devices-state';

const DevicesProviderContext = createContext({} as DevicesState);

export default DevicesProviderContext;
